import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { scrollToSection } from "../lib/scroll";

const IMG = "https://static.prod-images.emergentagent.com/jobs/a5c4951e-8f29-457c-9821-efbc601de008/images/";

const PROJECTS = [
  {
    id: "boulangerie",
    name: "Maison Aubry",
    sector: "Boulangerie artisanale",
    offer: "Starter",
    result: "Horaires, boutique et commandes du week-end en un coup d'œil.",
    img: `${IMG}56a7ecfcb75ed0480beeceaf53a41cbf0315cb5aff4d32db62d753635b2f9e5d.jpeg`,
  },
  {
    id: "avocat",
    name: "Cabinet Delorme Avocats",
    sector: "Cabinet d'avocats",
    offer: "Pro",
    result: "Présentation des domaines d'intervention et prise de rendez-vous en ligne.",
    img: `${IMG}e5cb541134d1061fd263734ecee0a3f90ebc50fdeecac98ca39635914eeb3f6c.jpeg`,
  },
  {
    id: "immobilier",
    name: "Horizon Immobilier",
    sector: "Agence immobilière",
    offer: "Premium",
    result: "Catalogue de biens avec filtres, carte et demandes de visite.",
    img: `${IMG}d7f6990eb29bcb5a26a9f0cf3b0d6dbab87e7d0a1fa6d7b8a1edae7dda4402e9.jpeg`,
  },
  {
    id: "menuiserie",
    name: "Atelier Bois & Sens",
    sector: "Menuiserie",
    offer: "Pro",
    result: "Galerie de réalisations et formulaire de devis qui remplit le carnet de commandes.",
    img: `${IMG}7890afe126c7c67f2d28c44b32e592129aa2af8c1d4029462d9f6fe572776aa5.jpeg`,
  },
];

const ProjectCard = ({ p }) => (
  <article
    data-testid={`portfolio-card-${p.id}`}
    className="group h-full overflow-hidden rounded-3xl border border-navy/10 bg-white transition-all duration-300 hover:-translate-y-1 hover:border-gold/40 hover:shadow-xl hover:shadow-gold/10"
  >
    <div className="relative overflow-hidden">
      <img src={p.img} alt={`Site internet réalisé pour ${p.name}`} loading="lazy" className="aspect-[16/10] w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" />
      <span className="absolute left-4 top-4 rounded-full bg-navy/85 px-3 py-1 font-mono text-[10px] font-semibold uppercase tracking-[0.14em] text-gold backdrop-blur">
        Formule {p.offer}
      </span>
    </div>
    <div className="p-6">
      <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-gold-dark">{p.sector}</p>
      <h3 className="mt-2 font-display text-xl font-bold text-navy">{p.name}</h3>
      <p className="mt-2 text-sm leading-relaxed text-slate-600">{p.result}</p>
    </div>
  </article>
);

export const Portfolio = () => (
  <section id="realisations" className="py-16 sm:py-24 lg:py-32" data-testid="portfolio-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
        <div className="max-w-2xl">
          <Reveal>
            <Eyebrow>Réalisations</Eyebrow>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-5 font-display text-2xl font-bold tracking-tight text-navy sm:text-3xl lg:text-4xl">
              Des sites qui travaillent pour leurs propriétaires.
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-4 text-base leading-relaxed text-slate-600">
              Chaque projet est pensé pour un métier précis : clair pour vos clients, simple à faire vivre pour vous.
            </p>
          </Reveal>
        </div>
        <Reveal delay={0.2}>
          <button
            data-testid="portfolio-cta"
            onClick={() => scrollToSection("contact")}
            className="group inline-flex items-center gap-2 rounded-full border border-navy/15 px-6 py-3 text-sm font-semibold text-navy transition-colors hover:border-gold hover:text-gold-dark"
          >
            Votre projet, le prochain ?
            <ArrowUpRight size={15} className="transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </button>
        </Reveal>
      </div>

      <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3" data-testid="portfolio-grid">
        {PROJECTS.map((p, i) => (
          <Reveal key={p.id} delay={i * 0.08} className={`h-full ${i % 3 === 0 ? "lg:col-span-2" : ""}`}>
            <ProjectCard p={p} />
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
